const IntegrationChip = ({ item }) => (
  <div
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: "8px",
      padding: "8px 16px",
      borderRadius: "8px",
      backgroundColor: "#0f1011",
      border: "1px solid #23252a",
      flexShrink: 0,
    }}
  >
    <div
      style={{
        width: "7px",
        height: "7px",
        borderRadius: "50%",
        backgroundColor: item.dot,
        flexShrink: 0,
      }}
    />
    <span style={{ color: "#8a8f98", fontSize: "13px", fontWeight: 500, whiteSpace: "nowrap" }}>
      {item.name}
    </span>
  </div>
);

const IntegrationsCarousel = ({ integrations }) => {
  const row1 = integrations;
  const row2 = [...integrations].reverse();

  return (
    <>
      <style>{`
        @keyframes marquee-left  { from { transform: translateX(0); } to { transform: translateX(-50%); } }
        @keyframes marquee-right { from { transform: translateX(-50%); } to { transform: translateX(0); } }
        .mw-marquee-l { animation: marquee-left  32s linear infinite; }
        .mw-marquee-r { animation: marquee-right 32s linear infinite; }
        .mw-marquee-l:hover, .mw-marquee-r:hover { animation-play-state: paused; }
      `}</style>
      <div style={{ overflow: "hidden", display: "flex", flexDirection: "column", gap: "10px" }}>
        <div style={{ overflow: "hidden" }}>
          <div className="mw-marquee-l" style={{ display: "flex", width: "200%", gap: "10px" }}>
            {[...row1, ...row1].map((item, i) => (
              <IntegrationChip key={`r1-${i}`} item={item} />
            ))}
          </div>
        </div>
        <div style={{ overflow: "hidden" }}>
          <div className="mw-marquee-r" style={{ display: "flex", width: "200%", gap: "10px" }}>
            {[...row2, ...row2].map((item, i) => (
              <IntegrationChip key={`r2-${i}`} item={item} />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default IntegrationsCarousel;
